<script setup lang="ts">
    import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogTrigger,
    } from '@/components/ui/alert-dialog';
    import { useI18n } from 'vue-i18n';
    import { useMutation } from '@tanstack/vue-query';
    import axios from 'axios';
    import { toast } from 'vue-sonner';
    import type { HolidayPayObligation } from '@/types';
    import { useQueryClient } from '@tanstack/vue-query';
    import QueryKey from '@/enums/QueryKey';
    import ContinueButton from '@/components/ContinueButton.vue';

    const queryClient = useQueryClient();

    const { t } = useI18n();

    const props = defineProps<{
        holidayPayObligation: HolidayPayObligation;
    }>();

    const { mutate, isPending } = useMutation({
        mutationFn: () =>
            axios.post(
                route('v2.salary.holiday-pay-obligations.export', {
                    companyId: props.holidayPayObligation.company_id,
                    id: props.holidayPayObligation.payroll_id,
                }),
            ),
        onSuccess: (data) => {
            toast.success(data.data.success || t('forms.general.success'));
            queryClient.invalidateQueries({
                queryKey: [QueryKey.HOLIDAY_PAY_OBLIGATIONS, props.holidayPayObligation.company_id],
            });
        },
        onError: (error: any) => {
            console.log('error', error);
            toast.error(error.response.data.error || t('forms.system_error'));
        },
    });
</script>

<template>
    <AlertDialog>
        <AlertDialogTrigger as-child>
            <ContinueButton>
                {{ t('holiday-pay-obligations.export') }}
            </ContinueButton>
        </AlertDialogTrigger>
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>
                    {{ t('holiday-pay-obligations.entries.economic.export.title') }}
                </AlertDialogTitle>
                <AlertDialogDescription>
                    {{ t('holiday-pay-obligations.entries.economic.export.content') }}
                </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel>{{ t('forms.no') }}</AlertDialogCancel>
                <AlertDialogAction
                    variant="default"
                    @click="mutate"
                >
                    {{ t('forms.yes') }}
                </AlertDialogAction>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
</template>
